module.exports = __webpack_public_path__ + "img/why-ojk.9f9ab526.svg";